import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSnackbar } from "notistack";
import ProtectedRoutes from "./services/ProtectedRoutes";
import Bridge from "./services/Bridge.js"
import Home from "./Components/Home/Home.jsx";

import Minecraft from "./Components/Minecraft/Home/Home.jsx";
import MinecraftLogin from "./Components/Minecraft/Login/Login.jsx";
import MinecraftRegister from "./Components/Minecraft/Register/Register.jsx";
import MinecraftShop from "./Components/Minecraft/Shop/Shop.jsx";
import MinecraftVip from "./Components/Minecraft/Vip/Vip.jsx";
import MinecraftCoins from "./Components/Minecraft/Coins/Coins.jsx";
import MinecraftBundles from "./Components/Minecraft/Bundles/Bundles.jsx";

import Loading from "./Components/Loading/Loading.jsx";
import Page404 from "./Components/Page404/Page404.jsx";

const App = () => {

	const { enqueueSnackbar } = useSnackbar();

	const bridge = new Bridge();

	const [user, setUser] = React.useState();
	const [ssoFetched, setSsoFetched] = React.useState(false);
	const [auth, setAuth] = React.useState(false);


    React.useEffect(()  => {

		const handleSso = async () => {

			try {
				const userData = await bridge.GET("userData");

				setUser(userData);
				setAuth(true);
				setSsoFetched(true);

				/* enqueueSnackbar("Auth was sactefful", {
				  variant: "success",
				  autoHideDuration: 3000,
				  onEntered: () => setAuth(true)
				});*/

			} catch (error) {
				setSsoFetched(true);
				/* if (error === "Access Token is expired or invalid") {
					setSsoFetched(true);
					return;
				}; */

				/* enqueueSnackbar(error, {
				  variant: "error",
				  autoHideDuration: 5000,
				  onEntered: () => setSsoFetched(true)
				}); */
			};
		};

	    handleSso();

    // eslint-disable-next-line
	}, []);

	const handleAuth = async () => {

		setSsoFetched(false);

		try {
			const userData = await bridge.GET("userData");

			setUser(userData);
			setAuth(true);

			setSsoFetched(true);

			/* enqueueSnackbar("Auth was sactefful", {
			  variant: "success",
			  autoHideDuration: 3000,
			  onEntered: () => setAuth(true)
			});*/

		} catch (error) {
			/* setSsoFetched(true);
			if (error === "Access Token is expired or invalid") {
				setSsoFetched(true);
				return;
			}; */

			enqueueSnackbar(error, {
			  variant: "error",
			  autoHideDuration: 5000,
			  onEntered: () => setSsoFetched(true)
			});
		};
	};

	return (
	    <BrowserRouter>
	        {!ssoFetched ?
				<Loading />
	      	    :
	        	<Routes>

	      		    <Route element={<ProtectedRoutes isAuthenticated={auth}/>}>

	      			    <Route element={
						    <MinecraftShop user={user} />

						} path="/minecraft/shop" exact/>

						<Route element={
							<MinecraftVip auth={auth} user={user} />

						} path="/minecraft/vip" exact/>

						<Route element={
							<MinecraftCoins auth={auth} user={user} />

						} path="/minecraft/coins" exact/>

						{/* <Route element={
							<MinecraftBundles auth={auth} user={user} />

						} path="/minecraft/bundles" exact/> */}

	      		    </Route>

	      		    <Route element={
						<Home/>

					} path="/" exact/>

					<Route element={
						<Minecraft auth={auth} user={user} />

					} path="/minecraft/" exact/>

					<Route element={
						<MinecraftLogin handleAuth={handleAuth} auth={auth} user={user} />

					} path="/minecraft/login" exact/>

					<Route element={
						<MinecraftRegister handleAuth={handleAuth} auth={auth} user={user} />

					} path="/minecraft/register" exact/>

	      		    <Route element={
						<Page404 />

					} path="*"/>

	      	    </Routes>
	        }
	    </BrowserRouter>
	);
};

export default App;
